import React from 'react'

const ClassPerformance = ({classes}) => {
  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title mb-4">Class Performance</h5>
          <div style={{ maxHeight: "500px", overflowY: "auto", overflowX:"hidden" }}>
          {classes.map((dept, idx) => (
            <div key={idx} className="card mb-3">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="card-title mb-0">{dept.name}</h6>
                  <span className="badge badge-primary">{dept.averageScore}%</span>
                </div>
                <div className="row">
                  <div className="col-4">
                    <small className="text-muted">Teachers</small>
                    <p className="mb-0 font-weight-bold">{dept.teachers}</p>
                  </div>
                  <div className="col-4">
                    <small className="text-muted">Students</small>
                    <p className="mb-0 font-weight-bold">{dept.students}</p>
                  </div>
                  <div className="col-4">
                    <small className="text-muted">Pass Rate</small>
                    <p className="mb-0 font-weight-bold">{dept.passRate}%</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ClassPerformance